import React, { useState, useEffect } from 'react';
import { Modal, Radio, Button, Row, Col, Input } from 'antd';
import { useTranslation } from "react-i18next";
import { CreditCardOutlined, GlobalOutlined, SisternodeOutlined, OpenAIOutlined, RocketOutlined, CalendarOutlined, EuroCircleOutlined, ContactsOutlined } from '@ant-design/icons';
import { useMediaQuery } from "react-responsive";
import styled from 'styled-components';
import HTTPClient from '../../utils/HTTPClient';

const StyledModal = styled(Modal)`
  .ant-modal-content {
    border-radius: 27px;
    overflow: hidden;
  }
  
  .ant-modal-body {
    padding: 0;
  }
`;

const ModalHeader = styled.div`
  display: flex;
  align-items: center;
`;


const ModalBody = styled.div`
  padding: 20px;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 20px;
`;

const StyledButton = styled(Button)`
  border-radius: 30px;
  margin: 0 10px;
  width: 200px;
  height: 50px;
`;

const BuyModal = ({ open }) => {
    const [subscriptionType, setSubscriptionType] = useState("yearly");
    const [promoCode, setPromoCode] = useState("");
    const [showPromoInput, setShowPromoInput] = useState(false);
    const [selectedPlan, setSelectedPlan] = useState("pro");
    const { t } = useTranslation();

    const buySubscription = async () => {
        const body = {
            subscription_type: subscriptionType,
            coupon: promoCode,
            plan: selectedPlan
        };
        try {
            await HTTPClient.post("/ab_home/get_stripe_session", body);
        } catch (e) {
            // redirect to checkout portal
            if (e.response.status === 303) {
                window.location.replace(e.response.data);
                return;
            }
            const { error_code } = e?.response?.data;
        }
    };

    const togglePromoInput = () => {
        setShowPromoInput(!showPromoInput);
    }

    const isLargeScreen = useMediaQuery({
        query: "(min-width: 771px)",
    });

    const selectedStyle = { border: "4px solid #5F4DEE", borderRadius: "10px" }

    const ProPlan = <>
        <Row style={{ justifyContent: "center", flexDirection: "column", alignContent: "center", marginBottom: "30px" }}>
            {subscriptionType === "monthly" ?
                <>
                    <Row style={{ justifyContent: "center" }}><p style={{ fontSize: "24px", fontWeight: "bold", lineHeight: 0 }}>{t("ab_home.buy_modal.pro.price_m")}</p></Row>
                    <Row><p style={{ fontSize: "12px", color: "#666", lineHeight: 0 }}>{t("ab_home.buy_modal.label_m")}</p></Row>
                </>
                :
                <>
                    <Row style={{ justifyContent: "center" }}><p style={{ fontSize: "24px", fontWeight: "bold", lineHeight: 0 }}>{t("ab_home.buy_modal.pro.price_y")}</p></Row>
                    <Row><p style={{ fontSize: "12px", color: "#666", lineHeight: 0 }}>{t("ab_home.buy_modal.label_y")}</p></Row>
                </>
            }
        </Row>
        <Row style={{ display: "flex", justifyContent: "center" }}>
            <Col span={16}>
                <Row>
                    <Col span={3}></Col>
                    <Col span={4}>
                        <GlobalOutlined twoToneColor="#52c41a" style={{ fontSize: "26px" }} />
                    </Col>
                    <Col span={15}>
                        {t("ab_home.buy_modal.pro.point1")}
                    </Col>
                </Row>
                <Row style={{ marginTop: "15px" }}>
                    <Col span={3}></Col>
                    <Col span={4}>
                        <SisternodeOutlined twoToneColor="#52c41a" style={{ fontSize: "26px" }} />
                    </Col>
                    <Col span={15}>
                        {t("ab_home.buy_modal.pro.point2")}
                    </Col>
                </Row>
                <Row style={{ marginTop: "15px" }}>
                    <Col span={3}></Col>
                    <Col span={4}>
                        <OpenAIOutlined twoToneColor="#52c41a" style={{ fontSize: "26px" }} />
                    </Col>
                    <Col span={15}>
                        {t("ab_home.buy_modal.pro.point3")}
                    </Col>
                </Row>
                <Row style={{ marginTop: "42px" }}>
                    <Col />
                </Row>
            </Col>
        </Row>
    </>
    const BusinessPlan = <>
        <Row style={{ justifyContent: "center", flexDirection: "column", alignContent: "center", marginBottom: "30px" }}>
            {subscriptionType === "monthly" ?
                <>
                    <Row style={{ justifyContent: "center" }}><p style={{ fontSize: "24px", fontWeight: "bold", lineHeight: 0 }}>{t("ab_home.buy_modal.business.price_m")}</p></Row>
                    <Row><p style={{ fontSize: "12px", color: "#666", lineHeight: 0 }}>{t("ab_home.buy_modal.label_m")}</p></Row>
                </>
                :
                <>
                    <Row style={{ justifyContent: "center" }}><p style={{ fontSize: "24px", fontWeight: "bold", lineHeight: 0 }}>{t("ab_home.buy_modal.business.price_y")}</p></Row>
                    <Row><p style={{ fontSize: "12px", color: "#666", lineHeight: 0 }}>{t("ab_home.buy_modal.label_y")}</p></Row>
                </>
            }
        </Row>
        <Row style={{ display: "flex", justifyContent: "center" }}>
            <Col span={16}>
                <Row>
                    <Col span={3}></Col>
                    <Col span={4}>
                        <GlobalOutlined twoToneColor="#52c41a" style={{ fontSize: "26px" }} />
                    </Col>
                    <Col span={15}>
                        {t("ab_home.buy_modal.business.point1")}
                    </Col>
                </Row>
                <Row style={{ marginTop: "15px" }}>
                    <Col span={3}></Col>
                    <Col span={4}>
                        <SisternodeOutlined twoToneColor="#52c41a" style={{ fontSize: "26px" }} />
                    </Col>
                    <Col span={15}>
                        {t("ab_home.buy_modal.business.point2")}
                    </Col>
                </Row>
                <Row style={{ marginTop: "15px" }}>
                    <Col span={3}></Col>
                    <Col span={4}>
                        <OpenAIOutlined twoToneColor="#52c41a" style={{ fontSize: "26px" }} />
                    </Col>
                    <Col span={15}>
                        {t("ab_home.buy_modal.business.point3")}
                    </Col>
                </Row>
                <Row style={{ marginTop: "15px" }}>
                    <Col span={3}></Col>
                    <Col span={4}>
                        <ContactsOutlined twoToneColor="#52c41a" style={{ fontSize: "26px" }} />
                    </Col>
                    <Col span={15}>
                        {t("ab_home.buy_modal.business.point4")}
                    </Col>
                </Row>
            </Col>
        </Row>
    </>

    return (
        <StyledModal
            open={open}
            footer={null}
            width={750}
            closeIcon={null}
            title={<div style={{ fontSize: "24px" }}><CreditCardOutlined style={{ color: "#5F4DEE", fontSize: "28px", marginRight: "10px" }} />{t("ab_home.buy_modal.title")}</div>}
        >
            <ModalHeader>

            </ModalHeader>
            <ModalBody>
                <Row>
                    {t("ab_home.buy_modal.text1")}
                </Row>
                <Row style={{ marginTop: "10px" }}>
                    {t("ab_home.buy_modal.text2")}
                </Row>
                <Row style={{ marginTop: "10px" }}>
                    {t("ab_home.buy_modal.text3")}
                </Row>

                <Row style={{ display: "flex", justifyContent: "center", marginTop: "40px" }}>
                    <Radio.Group onChange={(e) => setSubscriptionType(e.target.value)} value={subscriptionType} buttonStyle="solid">
                        <Radio.Button value="monthly">{t("builder.list.go_pro_modal.month")}</Radio.Button>
                        <Radio.Button value="yearly">{t("builder.list.go_pro_modal.year")}</Radio.Button>
                    </Radio.Group>
                </Row>
                <Row style={{ marginTop: "20px", display: "flex", justifyContent: "center" }}>
                    <Col span={isLargeScreen ? 12 : 24} style={selectedPlan === "pro" ? selectedStyle : { cursor: "pointer" }} onClick={() => setSelectedPlan("pro")}>
                        {ProPlan}
                    </Col>
                    <Col span={isLargeScreen ? 12 : 24} style={selectedPlan === "business" ? selectedStyle : { cursor: "pointer" }} onClick={() => setSelectedPlan("business")}>
                        {BusinessPlan}
                    </Col>
                </Row>
                <ButtonContainer>
                    <StyledButton
                        type="primary"
                        onClick={() => buySubscription()}
                        icon={<RocketOutlined rotate={45} />}
                    >
                        {t("ab_home.buy_modal.call_to_action")}
                    </StyledButton>
                </ButtonContainer>
                <a><Row onClick={() => togglePromoInput()} style={{ marginTop: "5px", fontSize: "12px", display: "flex", justifyContent: "center" }}>
                    {t("ab_home.buy_modal.have_coupon")}
                </Row></a>
                {showPromoInput &&
                    <Row style={{ marginTop: "10px", display: "flex", justifyContent: "center" }}>
                        <Input placeholder="PROMO CODE" value={promoCode} onChange={(e) => setPromoCode(e.target.value)} style={{ width: "40%" }} />
                    </Row>
                }
                <Row style={{ marginTop: "30px", fontSize: "12px" }}>
                    *{t("ab_home.buy_modal.text4")}
                </Row>
            </ModalBody>
        </StyledModal>
    );
};

export { BuyModal };